/**
 * Created by sswaminathan on 10/11/22
 * File: SingleTenantCSPDropDown
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Body } from '@panwds/react-ui'
import { useCallback, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { LICENSE_CONTEXT_TO_APP_ID } from '../../../../../common/constants/GlobalConstants'
import { getTSGInstancesBasedSupportAccount } from '../../../../../common/utils/Utils'
import { isNonemptyArray } from '../../../../../hub/utils/common'
import { SASE_SELECT_ACCOUNT } from '../../../../constants/LabelConstants'
import { SELECT_CSP } from '../../../constants/SubscriptionConstant'
/**
 *   TODO: Brief what is this component/class do
 */
import DropDown from '../../../dropdown/DropDown'
const SingleTenantCSPDropDown = (props) => {
  const { loading, setAppRegions, setPageError, licenseContext, apps, ...rest } = props

  const [selectedCSP, setSelectedCsp] = useState('')
  const [cspDisabled, disableCSP] = useState(false)
  const [cspAccounts, setCSPAccounts] = useState([])

  const { cspDropDownData, selectedTSGInstances } = rest
  const { setValue, formState, getValues } = useFormContext()
  const { errors } = formState

  const updateCSPAccounts = useCallback((supportAccounts) => {
    const cspAccount = isNonemptyArray(supportAccounts) && supportAccounts.length === 1 ? supportAccounts[0] : getValues('support_account')
    setSelectedCsp(cspAccount)
    setValue('support_account', cspAccount)
    setCSPAccounts(supportAccounts)
    disableCSP(isNonemptyArray(selectedTSGInstances) ? Boolean(cspAccount) : false)
  }, [getValues, selectedTSGInstances, setValue])

  useEffect(() => {
    try {
      if (!errors['tsg'] && isNonemptyArray(cspDropDownData)) {
        const supportAccounts = getTSGInstancesBasedSupportAccount({ tsgInstances: selectedTSGInstances, supportAccounts: cspDropDownData, app: apps[LICENSE_CONTEXT_TO_APP_ID[licenseContext]], reMapKeys: false })
        updateCSPAccounts(supportAccounts)
      }
      else if (errors['tsg']) {
        updateCSPAccounts(cspDropDownData)
      }
    }
    catch (e) {
      updateCSPAccounts([])
      setPageError(e.message)
    }
  }, [apps, cspDropDownData, errors, getValues, licenseContext, selectedTSGInstances, setPageError, updateCSPAccounts])

  const onCSPChange = useCallback((event) => {
    setSelectedCsp(event.target.value)
    setValue('support_account', event.target.value)
    setAppRegions({})
  }, [setAppRegions, setValue])

  return (<div>
    <DropDown
      addClassName='cmm-modal-select'
      itemList={cspAccounts}
      label={<Body addClassName="tw-font-lato tw-italic" as="span">{SASE_SELECT_ACCOUNT}</Body>}
      fieldName="support_account"
      height={null}
      width="100%"
      placeholderValue={selectedCSP ? null : SELECT_CSP}
      selectProps={{
        label: SASE_SELECT_ACCOUNT,
        showLabel: false,
        disabled: loading || cspDisabled,
        enableSearch: true,
        fullWidth: true,
        selectedItem: selectedCSP,
      }}
      changeHandler={onCSPChange}
    />
  </div>)
}

SingleTenantCSPDropDown.propTypes = {}
export default SingleTenantCSPDropDown
